import { render, staticRenderFns } from "./multi-register.vue?vue&type=template&id=52a45539&"
import script from "./multi-register.vue?vue&type=script&lang=js&"
export * from "./multi-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports